export default function TrustSafety() {
  const features = [
    {
      icon: 'ri-lock-password-line',
      title: 'Secure login',
      desc: 'Password-protected accounts with optional two-factor authentication for extra safety.',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Role-based access',
      desc: 'Family members, caregivers, and organizations only see what they need to see.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Private family care circles',
      desc: 'Each care circle is isolated. Only invited members can access shared information.',
    },
    {
      icon: 'ri-key-2-line',
      title: 'Encrypted data',
      desc: 'Sensitive information is protected with modern encryption both in transit and at rest.',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Privacy-conscious design',
      desc: 'Built with privacy regulations in mind. You control your data, and we respect that.',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Built around accessibility',
      desc: 'High contrast, large text, and voice-friendly options make CareBridge usable for everyone.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Simple enough for non-technical users',
      desc: 'No complicated menus or jargon. If you can use a phone, you can use CareBridge.',
    },
  ];

  return (
    <section id="trust-safety" className="bg-background-200/70 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-secondary-500/10 rounded-full px-3 py-1.5 mb-5">
            <i className="ri-shield-check-line text-secondary-500 text-xs"></i>
            <span className="text-xs font-semibold text-secondary-500 uppercase tracking-wider">Trust & Safety</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            Designed with privacy, safety, and simplicity in mind
          </h2>
          <p className="text-base md:text-lg text-foreground-600/80 max-w-2xl mx-auto leading-relaxed">
            We know that trust is everything when it comes to family care. CareBridge is built to protect what matters most.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 border border-background-200/70 hover:shadow-md transition-all duration-300 group cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-4">
                <i className={`${feature.icon} text-primary-500 text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600/80 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <div className="bg-white rounded-xl p-6 border border-background-200/70 max-w-2xl mx-auto">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-400/10 flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-accent-400 text-sm"></i>
              </div>
              <p className="text-sm text-foreground-600/80 text-left leading-relaxed">
                Health and emergency information should always be kept accurate and updated by the family or caregiver. CareBridge is designed to support communication and coordination, not to replace professional medical advice or emergency services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}